import { render } from "./IllegalSearchInfoDialog.vue?vue&type=template&id=6f2e073f&scoped=true"
import script from "./IllegalSearchInfoDialog.vue?vue&type=script&lang=js"
export * from "./IllegalSearchInfoDialog.vue?vue&type=script&lang=js"

import "./IllegalSearchInfoDialog.vue?vue&type=style&index=0&id=6f2e073f&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2e073f"]])

export default __exports__